// processTestimonials.tsx
// Extracts testimonials array and replaces the testimonials section with a placeholder. Returns { html, testimonialsSlides }

export interface ProcessedTestimonialsResult {
    html: string;
    testimonialsSlides: any[] | null;
}

export function processTestimonials(sectionHtml: string): ProcessedTestimonialsResult {
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHtml, 'text/html');
        const section = doc.querySelector('#testimonials, #testimonial');
        let testimonialsArray: any = undefined;
        if (section) {
            // Only support JSON script
            const jsonScript = section.querySelector('script[type="application/json"]');
            if (jsonScript && jsonScript.textContent) {
                let jsonText = jsonScript.textContent.trim();
                // If the JSON is an array with single quotes, fix to double quotes and wrap in an object
                if (jsonText.startsWith("[") && jsonText.endsWith("]")) {
                    jsonText = jsonText.replace(/'/g, '"');
                    try {
                        testimonialsArray = JSON.parse(jsonText);
                    } catch (jsonErr) {
                        // Debug log removed
                    }
                } else {
                    // Fallback: try to parse as object with slides property
                    jsonText = jsonText.replace(/'/g, '"');
                    try {
                        const obj = JSON.parse(jsonText);
                        if (Array.isArray(obj.slides)) {
                            testimonialsArray = obj.slides;
                        }
                    } catch (jsonErr) {
                        // Debug log removed
                    }
                }
            }
            if (Array.isArray(testimonialsArray) && testimonialsArray.length > 0) {
                // Replace the testimonials section with a placeholder for React injection
                section.replaceWith(document.createComment('TESTIMONIALS_PLACEHOLDER'));
                return {
                    html: doc.body.innerHTML,
                    testimonialsSlides: testimonialsArray
                };
            }
        }
        return { html: sectionHtml, testimonialsSlides: null };
    } catch (error) {
        console.error('[processTestimonials] Error:', error);
        return { html: sectionHtml, testimonialsSlides: null };
    }
}
